import React, { useContext } from 'react';
import { Row, Button, Container, Col, Modal, Fade } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { RouteComponentProps, Redirect } from 'react-router';
import { Result } from 'models/Result';
import { Resultview } from './ResultView';
import l10n from 'localization/LocalizationData';
import copy from 'copy-to-clipboard';
import QuestionnaireContext from 'contexts/QuestionnaireContext';
import { MainLayout } from 'components/layouts/MainLayout';
import { ResultPrintView } from './ResultPrintView';

interface ShareFieldProps {
	id: string;
	title: string;
	shareableText: string;
	copyButtonText: string;
	copiedText: string;
	class?: string;
}

const ShareField = (props: ShareFieldProps) => {
	const [copied, setCopied] = React.useState(false);
	const shareRef = React.useRef<any>();

	function pasteTrigger() {
		const shareCode = shareRef.current as HTMLInputElement;
		shareCode.select();
		setCopied(copy(shareCode.value));
	}

	return (
		<div className='share-field'>
			<Col xs='12' className='text-center'>
				<label htmlFor={props.id}
					className='mb-0'>
					{props.title}
				</label>
			</Col>
			<Col xs>
				<input id={props.id}
					type='text'
					ref={shareRef}
					onClick={pasteTrigger}
					onChange={() => { }}
					className='result-code-field'
					value={props.shareableText} />
			</Col>
			<Col xs='12' className='mb-3 copy-result-area justify-content-center text-center'>
				<Fade in={copied}>
					<p className='mb-0 copied-text'>{props.copiedText}</p>
				</Fade>
			</Col>
			<Col xs='auto'>
				<Button onClick={pasteTrigger}>{props.copyButtonText}</Button>
			</Col>
		</div>
	);
}

export const ShareView = (props: RouteComponentProps<{}, {}>) => {
	const [showShareModal, setShowShareModal] = React.useState(false);
	const routeState = props.location.state as any;
	const context = useContext(QuestionnaireContext);

	const code = routeState?.['code'] as string;
	const result = routeState?.['result'] as Result;

	if (result === undefined) {
		return <Redirect to='/' />
	}

	if (context.token) {
		context.finish();
	}

	function onShareModalhide() {
		setShowShareModal(false);

	}

	return (
		<MainLayout header={
			<div className='share-header'>
				<a className='survey-btn' href='https://link.webropolsurveys.com/S/7880410DFA22C2D8' target='_blank' rel='noopener noreferrer'>
					<Button className='no-print'>{l10n.resultSharing_survey}</Button>
				</a>
				<LinkContainer to='/'>
					<Button className='no-print'>{l10n.button_toHome}</Button>
				</LinkContainer>
			</div>
		}>
			<Container>
				<Modal size='lg' aria-labelledby='shareResultTitle' show={showShareModal} onHide={() => onShareModalhide()}>
					<Modal.Header closeButton={true}>
						<Modal.Title id='shareResultTitle'>{l10n.resultSharing_title}</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<Row>
							<Col><p>{l10n.resultSharing_description}</p></Col>
						</Row>
						<ShareField id='codeShare'
							title={l10n.resultSharing_codeShare}
							shareableText={code}
							copyButtonText={l10n.button_copyCode}
							copiedText={l10n.resultSharing_codeShare_copied} />


						<Row className='justify-content-center text-center my-3'>
							<Col><p className='mb-0'><b>Tai</b></p></Col>
						</Row>
						<ShareField id='urlShare'
							title={l10n.resultSharing_urlShare}
							shareableText={`${window.location.origin}/result/${code}`}
							copyButtonText={l10n.button_copyUrl}
							copiedText={l10n.resultSharing_urlShare_copied} />

					</Modal.Body>
					<Modal.Footer className='justify-content-around text-center'>
						<Col><Button onClick={() => { setShowShareModal(false) }}>{l10n.button_exit}</Button></Col>
					</Modal.Footer>
				</Modal>
				<h1 className='mt-4 mb-2'>{result.questionnaire.resultName !== undefined ? result.questionnaire.resultName : result.questionnaire.name}</h1>
				<div className='result-code-container mb-4'>
					<div className='result-code'><p>{l10n.answers_resultCode} <b className='result-code-bold'>{code}</b> {l10n.answers_resultCode_end}</p></div>
					<Col xs='auto' className='no-print result-share-opener'>
						<Button onClick={() => setShowShareModal(true)}>{l10n.button_shareResult}</Button>
					</Col>
				</div>


				<ResultPrintView result={result} />
				<Resultview result={result} />
				<Row className='my-3 hide-print justify-content-center'>
					<Col xs='auto'>
						<Button variant='primary' className='no-print' onClick={() => { window.print() }}>{l10n.button_printPdf}</Button>
					</Col>
				</Row>
			</Container >
		</MainLayout >
	);
}